
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/international-network",
      function () {
        return require("private-next-pages/international-network.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/international-network"])
      });
    }
  